import script from "./ManageIdentitiesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManageIdentitiesPage.vue?vue&type=script&lang=ts&setup=true"

import "./ManageIdentitiesPage.vue?vue&type=style&index=0&id=51ff78b5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51ff78b5"]])

export default __exports__